"use client";

import AppLayout from "../../../navigation/Layout/Layout";
import MainFeed from "../../components/FeedPage/MainFeed/MainFeed";
import Sidebar from "../../components/FeedPage/Sidebar/Sidebar";
import "./Feed.css";

export default function Feed() {
  return (
    <AppLayout>
      <div className="feed-main">
        <div className="feed-row">
          <div className="feed-maincol">
            <MainFeed />
          </div>
          <div className="feed-rightcol">
            <Sidebar />
          </div>
        </div>
      </div>
    </AppLayout>
  );
}
